import * as Library from '../../../../lib/core/library/index';
import { Simple } from '../../../../lib/core/common/simple';
import { Model } from './model';
import { Engine } from './engine';
import { Transmission } from './transmission';
import { Option } from './option';
import { ExteriorColor } from './exteriorColor';
import { InteriorColor } from './interiorColor';
import { Media } from './media';
import { Price } from './price';
import { MPG } from './mpg';
import { StandardOption } from './standard-option';
import { SaftyRating } from './saftyRating';
import { Promote } from './promote';

export class Vehicle extends Simple {
  public vin: string;
  public stockNum: string;
  public brand: string;
  public marketingSeries: string;
  public seriesCode: string;
  public year: number;
  public dealerCd: string;
  public bodyStyleDesc: string;
  public model: Model;
  public engine: Engine;
  public transmission: Transmission;
  public options: Option[];
  public holdStatus: string;
  public extColor: ExteriorColor;
  public intColor: InteriorColor;
  public media: Media[];
  public price: Price;
  public mpg: MPG;
  public standardOptions: StandardOption;
  public saftyRatings: SaftyRating;
  public promoteDescription: Promote;
  public disclaimer: string[];
  public weightRating: string;

  /*
   * Constructor()
   */
  constructor();
  constructor(options: object);
  constructor(options?: any) {
    super(options);
    this.vin = Library.init(options, 'vin');
    this.stockNum = Library.init(options, 'stockNum');
    this.brand = Library.init(options, 'brand');
    this.marketingSeries = Library.init(options, 'marketingSeries');
    this.seriesCode = Library.init(options, 'seriesCode');
    this.year = Library.init(options, 'year', 0);
    this.dealerCd = Library.init(options, 'dealerCd');
    this.bodyStyleDesc = Library.init(options, 'bodyStyleDesc');
    this.model = new Model(Library.init(options, 'model', {}));
    this.engine = new Engine(Library.init(options, 'engine', {}));
    this.transmission = new Transmission(Library.init(options, 'transmission', {}));

    this.options = [];
    if (Library.hasOwnProperty(options, 'options')) {
      this.options = options.options.map(o => new Option(o));
    }

    this.holdStatus = Library.init(options, 'holdStatus');
    this.extColor = new ExteriorColor(Library.init(options, 'extColor', {}));
    this.intColor = new InteriorColor(Library.init(options, 'intColor', {}));

    this.media = [];
    if (Library.hasOwnProperty(options, 'media')) {
      this.media = options.media.map(o => new Media(o));
    }

    this.price = new Price(Library.init(options, 'price', {}));
    this.mpg = new MPG(Library.init(options, 'mpg', {}));
    this.standardOptions = new StandardOption(Library.init(options, 'standardOptions', {}));
    this.saftyRatings = new SaftyRating(Library.init(options, 'saftyRatings', {}));
    this.promoteDescription = new Promote(Library.init(options, 'promoteDescription', {}));
    this.disclaimer = [];
    if (Library.hasOwnProperty(options, 'disclaimer')) {
      this.disclaimer = options.disclaimer;
    }
    this.weightRating = Library.init(options, 'weightRating');
  }
}






